export default "__VITE_ASSET__1MKolc7c__"